import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-touch-point-privacy-fields',
  templateUrl: './touchPointPrivacyFields.component.html'
})
export class TouchPointPrivacyFieldsComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() actions;
  @Input() privacyList: FormArray;
  @Output() deleteElement = new EventEmitter();

  rowNumbers: number[] = [];

  controls() {
    return (<any>this.form.get('privacyList')).controls;
  }

  constructor() {}

  ngOnInit(): void {
    if (this.form.controls['privacyList'].value.length > 0) {
      this.rowNumbers = [];
      for (let i = 0; i < this.form.controls['privacyList'].value.length; i++) {
        this.rowNumbers[i] = this.form.controls['privacyList'].value[i].row_number;
      }
    }
  }

  deletePrivacyList(index) {
    this.deleteElement.emit(index);
  }

  // FIXME: Altezza statica dell'accordion contenente campi privacy
  //  wrappata in un div sennò primeng non renderizza bene l'altezza
  //  dei contenuti dinamici all'interno dell'elemento accordion'

}


// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/components/touchPointPrivacyFields.component.ts